import React from 'react';

// The Hub by ZG Books — three ascending bars mark. Inherits the current text colour.
export function BrandMark({ size = 28 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" style={{ display: 'block', color: 'var(--accent)' }}>
      <rect x="3" y="13" width="4.6" height="8" rx="1.2" />
      <rect x="9.7" y="8" width="4.6" height="13" rx="1.2" />
      <rect x="16.4" y="3" width="4.6" height="18" rx="1.2" />
    </svg>
  );
}

// Mark + wordmark, used on the login and client portals.
export function BrandLockup({ size = 40, name = 'The Hub', tag = 'by ZG Books' }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '8px' }}>
      <BrandMark size={size} />
      <div style={{ textAlign: 'center' }}>
        <div style={{ fontSize: '22px', fontWeight: 700, letterSpacing: '0.2px', color: 'var(--text)' }}>{name}</div>
        {tag && <div style={{ fontSize: '12px', letterSpacing: '0.3px', color: 'var(--text-muted)' }}>{tag}</div>}
      </div>
    </div>
  );
}
